// DS: i6.21
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import IconWrap, { Props } from '../../IconWrap';

const ChangeBg: React.FC<Props> = props => {
  const uniqueId = useUniqueId();
  const gradientId = `icon-i08-${uniqueId}-a`;

  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id={gradientId}
            x1="10.264%"
            x2="91.383%"
            y1="9.695%"
            y2="91.6%"
          >
            <stop offset="0%" stopColor="#FCF53C"></stop>
            <stop offset="43.255%" stopColor="#FF5DD3"></stop>
            <stop offset="64.162%" stopColor="#078BFB"></stop>
            <stop offset="100%" stopColor="#06D290"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 3)">
          <rect
            width="18"
            height="18"
            x="1"
            fill={`url(#${gradientId})`}
            rx="1"
          ></rect>
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M19 0a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h18zm-1 2H2v14h16V2z"
          ></path>
        </g>
      </svg>
    </IconWrap>
  );
};
ChangeBg.displayName = 'ChangeBg';

export default ChangeBg;
